import { Box, Stack, Tooltip, Typography } from "@mui/material"
import { useState } from "react"
import Iconify from "minimals-template/components/Iconify"
import { Case, Switch } from "lib/@components/switch"
import { ToBeSaved } from "lib/@components/save-indicator/to-be-saved"
import { QueuedIcon } from "lib/@components/save-indicator/queued-icon"

export function InternalIndicator({ id, priority: __priority }) {
    const [changes, setChanges] = useState(false)
    ToBeSaved(id).useEvent((value) => {
        if (value instanceof Error && value.message.startsWith("Deferring")) {
            setChanges(false)
            return
        }
        setChanges(value)
    })

    const state = computeState(changes)
    const tooltip = tooltipForState(state)

    return (
        <Tooltip arrow title={tooltip}>
            <Box sx={{ color: "text.primary", minWidth: 120 }} data-cy="save-indicator">
                <Stack direction="row" spacing={1} sx={{ color: "text.secondary" }} alignItems="center">
                    <Box sx={{ lineHeight: 0 }}>
                        <Switch value={state}>
                            <Case when="pending">
                                <Iconify sx={{ color: "warning.main" }} icon="teenyicons:save-solid" />
                            </Case>
                            <Case when="queued">
                                <QueuedIcon sx={{ color: "warning.dark", width: 20, height: 20 }} />
                            </Case>
                            <Case when="error">
                                <Iconify sx={{ color: "error.main" }} icon="teenyicons:save-solid" />
                            </Case>
                            <Case when="saved">
                                <Iconify sx={{ color: "success.main" }} icon="mdi:tick" />
                            </Case>
                        </Switch>
                    </Box>
                    <Typography variant="body2" component="div">
                        <Switch value={state}>
                            <Case when="pending">Pending</Case>
                            <Case when="queued">Saved locally</Case>
                            <Case when="error">Error</Case>
                            <Case when="saved">Saved</Case>
                        </Switch>
                    </Typography>
                </Stack>
            </Box>
        </Tooltip>
    )

    function computeState(changes) {
        if (changes === "queued") return "queued"
        if (changes instanceof Error) return "error"
        if (changes) return "pending"
        return "saved"
    }

    function tooltipForState(state) {
        if (state === "pending") return "Save will complete if you leave the page, but not if you close the browser"
        if (state === "queued")
            return "Your changes are safe on this device. They will sync to the server when the connection is restored."
        return undefined
    }
}
